import React from "react";
import {ReadMoreReadLess} from "@tkww/ads-content-component-fashion";

const ReadMoreComponent = ({content}) => {
  return (
    <ReadMoreReadLess
      content={content}
    />
  );
}

export default ReadMoreComponent;